import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=408450a6"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=408450a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Title: require('/app/components/title.vue').default,BlockContacts: require('/app/components/block/contacts.vue').default,BlockBenefits: require('/app/components/block/benefits.vue').default})
